export const YouTubeVideoLink = ({
  title,
  mediaId,
}: {
  title: string;
  mediaId: string;
}) => (
  <iframe
    title={title}
    className="aspect-video"
    src={`https://www.youtube.com/embed/${mediaId}?rel=0&modestbranding=1`}
    frameBorder="0"
    allowFullScreen
    width={'100%'}
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  />
);
